export interface II18nConfig {
  locale: string;
  table: ITableI18n;
  editableTable: IEditableI18n;
  filter: IFilterI18n;
  tagSelect: ITagSelectI18n;
}

export interface IFilterI18n {
  filter: string;
  all: string;
  reset: string;
}

export interface IEditableI18n {
  options: string;
  edit: string;
  delete: string;
  save: string;
  cancel: string;
  input: string;
  addText: string;
  deleteConfirm: string;
}
export interface ITableI18n {
  total: string;
}

export interface ITagSelectI18n {
  cancel: string;
  confirm: string;
  createNewTag: string;
}
